// src/components/research/quote.js

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/* A single statement, lifted out of the running text.
   ------------------------------------------------------------------------
   The first of the three set-aside shapes; see callout.js for the full set
   and the rule for choosing between them.

   No frame and no label. A Callout is boxed because it holds something placed
   beside the argument, and a box says "this is separate". What goes in a
   Quote is not separate from the argument, so it gets an accent rule and a
   narrower measure and nothing else. Pulled in from both edges it reads as a
   pause in the middle of the page rather than as another paragraph that
   someone has marked. */
const StyledQuote = styled.div`
  max-width: 32rem;
  margin: var(--space-2) var(--space-5) 2rem;
  padding: var(--space-2) 0 var(--space-1) var(--space-5);
  border-left: 2px solid var(--accent);

  p {
    margin: 0;
    max-width: none;
    color: var(--text-emphasis);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: var(--lh-body);
    letter-spacing: -0.01em;
  }

  @media (max-width: 600px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

const Quote = ({ children }) => (
  <StyledQuote>
    <p>{children}</p>
  </StyledQuote>
);

Quote.propTypes = { children: PropTypes.node.isRequired };

export default Quote;
